<template>
  <div class="login-container">
    <van-form @submit="onSubmit" :show-error="false" label-width="0">
      <van-field
        v-model="form.userName"
        clearable
        placeholder="请输入姓名/名称"
        :rules="[{ required: true, message: '必填', trigger: 'onChange' }]"
      />
      <van-field
        readonly
        clickable
        v-model="idName"
        placeholder="请选择证件照类型"
        :rules="[{ required: true, message: '必选', trigger: 'onChange' }]"
        @click="showPicker = true"
      />
      <van-field
        v-model="form.idNum"
        clearable
        placeholder="请输入证件号码"
        :rules="[{ required: true, message: '必填', trigger: 'onChange' }]"
      />
      <van-field
        v-model="form.password"
        type="password"
        name="password"
        clearable
        placeholder="请输入密码"
        :error-message="errMsg.password"
        @change="validatePassword"
      >
      </van-field>
      <van-field
        v-model="form.rePassword"
        type="password"
        name="rePassword"
        clearable
        placeholder="请再次输入密码"
        :error-message="errMsg.rePassword"
        @change="equalPassword"
      >
      </van-field>
      <van-field>
        <template #input>
          <van-field
            v-model="form.random"
            class="nobd"
            maxlength="5"
            clearable
            placeholder="请输入验证码"
            :rules="[{ required: true, message: '必填', trigger: 'onChange' }]"
          />
          <van-image
            @click="getValidCode"
            width="140"
            height="35"
            :src="valid_code_url"
          />
        </template>
      </van-field>
      <div class="login-btn">
        <van-button block type="info" native-type="submit"> 注　册 </van-button>
      </div>
      <div class="login-btn">
        <van-button block @click="login"> 返　回 </van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import log from "utils/log";
import apiLoginPage from "api/login-page";
import utils from "@/utils/util";
import { saveToken } from "@/utils/cache";
import rsaKeyUtil from "@/utils/RsaKeyUtil";
import { md5 } from "@/utils/md5";
import store from "@/store";
export default {
  name: "register",
  data() {
    return {
      showPicker: false,
      valid_code_url: "",
      idName: "",
      columns: [],
      form: {
        idType: "",
        idNum: "",
        password: "",
        userName: "",
        random: "",
        rePassword: "",
      },
      errMsg: {
        password: "",
        rePassword: "",
      },
      isWx: utils.isWeChatBrowser()
    };
  },
  created() {
    this.getValidCode();
    this.getCardType();
  },
  methods: {
    validatePassword() {
      let reg = /((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*.])|(?=.*\d)(?=.*[#@!~%^&*.]))[a-z\d#@!~%^&*.]{8,20}/;
      if (reg.test(this.form.password)) {
        this.errMsg.password = "";
        return true;
      } else {
        this.errMsg.password =
          "密码必须是8-20个字符,不包含空格,必须包含数字,字母或字符至少两种,字符可使用#@!~%^&*.,";
        return false;
      }
    },
    equalPassword() {
      if (this.form.rePassword == this.form.password) {
        this.errMsg.rePassword = "";
        return true;
      } else {
        this.errMsg.rePassword = "密码必须与新密码保持一致";
        return false;
      }
    },
    login() {
      this.$router.replace({ name: "login" });
    },
    onConfirm(cardType) {
      this.idName = cardType.name;
      this.form.idType = cardType.id;
      this.showPicker = false;
    },
    getValidCode() {
      let d = new Date();
      let url = this.wConfig.VUE_APP_BASE_API;
      let url2 = url + "/shiro/get/random/image?" + d.getTime();
      this.valid_code_url = url2;
    },
    getCardType() {
      apiLoginPage.registerCardType().then((res) => {
        this.columns = res.data;
        console.log(res);
      });
    },
    reset() {
      this.idName = "";
      this.form = {
        idType: "",
        idNum: "",
        password: "",
        userName: "",
        random: "",
        rePassword: "",
      };
    },
    onSubmit(values) {
      let { idType, password, rePassword, idNum, random, userName } = this.form;
      if (password != rePassword) {
        this.$notify({
          message: "两次密码输入不一致。",
          type: "warning",
        });
        return;
      }
      password = rsaKeyUtil.encrypt(md5(password));
      let param = {
        idType: idType,
        password: password,
        rePassword: password,
        idNum: rsaKeyUtil.encrypt(idNum),
        userName,
        random,
      };
      apiLoginPage
        .register(param)
        .then((res) => {
          saveToken(res.data);
          this.$store.dispatch('mars/user/getUserInfo')

          if(this.isWx) {
						// 绑定openid
						let params = {}
						let openId = this.$store.getters.openId
						if(utils.isNotEmpty(openId)) {
							params.openId = openId
						} else {
							this.$store.dispatch('mars/user/setLoginStatus', 0).then(
								this.$router.push({ path:'/' })
							)
						}
						this.$store.dispatch('mars/user/bindUser', params).then(() => {
							this.$router.push({ path:'/home' })
						})
						.catch( (err) => {
							console.log('绑定用户出错了' + err)
						})
					}

          this.$router.replace({ name: "home" });
        })
        .catch(() => {
          this.getValidCode();
        });
    },
  },
};
</script>

<style lang='scss'>
.nobd.van-field {
  padding-left: 0;
  &::after {
    border: none;
  }
}
</style>
